var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.className,attrs:{"aria-hidden":"true"},on:{"click":_vm.handleClick}},[_c('use',{attrs:{"href":("#icon-" + _vm.iconClass)}})])}
var staticRenderFns = []

export { render, staticRenderFns }